import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import AuthReducer from "./Slice/AuthSlice";
import DashboardReducer from "./Slice/DashboardSlice";
import OrdersReducer from "./Slice/OrdersSlice";
import PositionReducer from "./Slice/PositionSlice";
import HoldingsReducer from "./Slice/HoldingsSlice";
import fundsReducer from "./Slice/FundsSlice";
import advisorsReducer from "./Slice/AdvisorsSlice";
import advisorAuthReducer from "./Slice/AdvisorAuthSlice";
import baseApi from "./api/baseApi";

const persistConfig = {
  key: "1",
  storage,
};

const reducer = combineReducers({
  auth: AuthReducer,
  dashboard: DashboardReducer,
  orders: OrdersReducer,
  position: PositionReducer,
  holdings: HoldingsReducer,
  funds: fundsReducer,
  advisors: advisorsReducer,
  advisorauth: advisorAuthReducer,
  
  [baseApi.reducerPath]: baseApi.reducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(baseApi.middleware), 
});

export default store;

